<template>
	<div class="overlay-test">
		<div class="overlay-bg-test"></div>
		<div v-if="isGallery">
			<span class="hand-icon hand-right"></span>
			<h3 class="hand-right-text"><span v-html="t('overlay.then_vs_now_gallery_click')"></span></h3>
		</div>
		<span class="hand-icon hand-left"></span>
		<h3 class="hand-left-text"><span v-html="t('overlay.then_vs_now_move_slider')"></span></h3>
		<OverlayButton text="OK!" />
		<div class="overlay-layer"></div>
	</div>
</template>

<script>
import OverlayButton from "@/components/overlay/OverlayButton.vue";
import { useI18n } from "vue-i18n";

export default {
	name: "ThenVsNowOverlay",
	props: {
		isGallery: Boolean,
	},
	components: {
		OverlayButton,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
};
</script>

<style scoped>
.overlay-test {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

.overlay-bg-test {
	position: absolute;
	z-index: var(--global-z-index-overlay);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(8, 35, 42, 0.85);
}

.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
}

.overlay-info-test {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
}

.hand-icon {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/hand.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 112px;
	width: 84px;
}

.hand-left {
	position: absolute;
	left: 80px;
	bottom: 100px;
	animation: hand-move-left-right 1.5s infinite linear;
}

@keyframes hand-move-left-right {
	0% {
		left: 80px;
	}
	50% {
		left: 120px;
	}
	100% {
		left: 80px;
	}
}

.hand-right {
	position: absolute;
	right: 35px;
	top: 47%;
}

.hand-left-text {
	z-index: var(--global-z-index-overlay-info);
	position: absolute;
	left: 200px;
	bottom: 100px;
	color: white;
}

.hand-right-text {
	z-index: var(--global-z-index-overlay-info);
	position: absolute;
	right: 135px;
	top: 47%;
	color: white;
}

.overlay-layer {
	position: absolute;
	z-index: var(--global-z-index-overlay-layer);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}
</style>

<style>
/* .icv__circle::after {
    visibility: var(--global-overlay-status);
    position: absolute;
    content: '';
    z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/hand.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 112px;
	width: 84px;
} */
</style>